import api from '@/api';

export default {
    namespaced: true,

    state: {},

    actions: {

        async getStickerTemplates(context, obj) {
            let url = `/admin/sticker_templates`;
            const response = await api.request('get', url);
            return response.data;
        },
        async getStickerTemplate(context, item) {
            let url = `/admin/sticker_templates/${item.uid}`;
            const response = await api.request('get', url);
            return response.data;
        },
        async editStickerTemplateName(context, item) {
            let url = `/admin/sticker_templates/${item.uid}/name`;
            const response = await api.request('put', url, item);
            return response.data;
        },
        async duplicateStickerTemplate(context, item) {
            let url = `/admin/sticker_templates/${item.uid}/duplicate`;
            const response = await api.request('post', url, item);
            return response.data;
        },
        async editStickerTemplate(context, item) {
            let url = `/admin/sticker_templates/${item.uid}`;
            const response = await api.request('put', url, item);
            return response.data;
        },
        async createStickerTemplate(context, item) {
            let url = `/admin/sticker_templates`;
            const response = await api.request('post', url, item);
            return response.data;
        },
        async deleteStickerTemplate(context, item) {
            let url = `/admin/sticker_templates/${item.uid}`;
            const response = await api.request('delete', url, item);
            return response.data;
        },

    },
    mutations: {}
};
